<template>
    <div class="nswitch">
        <div v-if="labelRight" class="side-label label-right">
            {{ labelRight }}
        </div>
        <v-switch v-model="inputValue" color="primary" hide-details
                  :disabled="isDisabled"
                  class="nswitch__input"></v-switch>

        <div v-if="labelLeft" class="side-label label-left">
            {{ labelLeft }}
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { VSwitch } from 'vuetify/lib/components';
    import { VNode } from 'vue';

    @Component
    export default class nSwitchcomponent extends Vue {
        @Prop({ type: String, default: '' }) labelLeft!: string;
        @Prop({ type: String, default: '' }) labelRight!: string;
        @Prop({ type: Boolean, default: true }) flat!: boolean;
        @Prop({ type: Boolean, default: true }) hideDetails!: boolean;
        @Prop({ type: Boolean, default: false }) toggle!: boolean;

        inputValue = false; // Default value, adjust as needed
        isDisabled = false; // Manage disabled state if needed

        public mounted() {
            this.inputValue = this.toggle;
            console.log('NSwitch mounted with:', {
                labelLeft: this.labelLeft,
                labelRight: this.labelRight,
                flat: this.flat,
                hideDetails: this.hideDetails,
                inputValue: this.inputValue
            });
        }
        @Watch('inputValue')
        private onToggle() {
            //this.inputValue = value.returnValue;
            this.$emit('update:modelValue', this.inputValue);
            console.log('NSwitch onToggle:', {
                labelLeft: this.labelLeft,
                labelRight: this.labelRight,
                flat: this.flat,
                hideDetails: this.hideDetails,
                inputValue: this.inputValue
            });
        }
    }
</script>

<style lang="scss" scoped>
    .nswitch {
        display: flex;
        align-items: center;

        .nswitch__input {
            margin: 4px 2px 5px 8px;
            color: var(--layout-primary-color) !important;
            caret-color: var(--layout-primary-color) !important;
            /*padding-top:5px !important;*/
        }

        :deep(.v-input--switch__thumb) {
            color: var(--layout-primary-color) !important;
            top: calc(50% - 5px) !important;
            width: 12px !important;
            height: 12px !important;
        }

        :deep(.v-input--switch__track) {
            color: rgba(0, 0, 0, .38) !important;
            top: calc(50% - 2px) !important;
            height: 6px !important;
            width: 40px !important;
            left: 3px;
            right: -3px;
        }

        :deep(.v-input--selection-controls__ripple) {
            display: none;
        }
    }
</style>